module.exports = __webpack_public_path__ + "assets/img/5_1157_big.4774655c.jpg";